import "./related-content-block.scss";

(function () {
    if (document.querySelectorAll(".js-related-content-block").length > 0) {
        const relatedContentBlock = {
            init: function () {
                this.ShortenCardText();
            },
            ShortenCardText: function () {
                const rcb = document.getElementsByClassName("card__preamble_shorten");
                const shortenCardLength = 115;            
                for (const paragraph of rcb) {
                    const rcblength = paragraph.innerHTML.length
                    if (rcblength > shortenCardLength) {
                        paragraph.innerHTML = paragraph.innerHTML.substring(0, shortenCardLength) + "...";
                    }
                    
                }

            },
        };

        relatedContentBlock.init();
    }
})();
